import { useNowMinute } from "./useNowMinute.js";

interface Props {
  /** px per hour (matches the grid's vertical zoom). */
  hourHeight: number;
}

/**
 * A thin shadowed line marking the current time, spanning ONE day column.
 * Rendered by DayColumn only for today's column.
 */
export function CurrentTimeBar({ hourHeight }: Props) {
  const now = useNowMinute();
  const minutes = now.getHours() * 60 + now.getMinutes();
  const top = (minutes / 60) * hourHeight;
  return (
    <div className="pointer-events-none absolute inset-x-0 z-30" style={{ top }} aria-hidden>
      <div className="relative h-0.5 w-full bg-red-500 shadow-[0_1px_2px_rgba(0,0,0,0.4)]">
        <div className="absolute left-0 top-1/2 h-2 w-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-red-500 shadow" />
      </div>
    </div>
  );
}
